import React, { useContext, useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { FiMenu, FiX, FiPlus, FiLogOut } from "react-icons/fi";
import { UserContext } from "../context/userContext";
import { FALLBACK_AVATAR, fallbackTo, uploadUrl } from "../constants";

const LINKS = [
  { to: "/", label: "Feed", end: true },
  { to: "/authors", label: "Authors" },
  { to: "/ai", label: "AI Notes" },
  { to: "/fact", label: "QuickLearn" },
];

const Header = () => {
  const [open, setOpen] = useState(false);
  const { currentUser } = useContext(UserContext);
  const { pathname } = useLocation();

  useEffect(() => setOpen(false), [pathname]);

  return (
    <header className="nav">
      <div className="container nav__inner">
        <Link to="/" className="brand" aria-label="BrainBytes home">
          <span className="brand__mark">B</span>
          BrainBytes
        </Link>

        <nav className="nav__links" aria-label="Primary">
          {LINKS.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.end} className="nav__link">
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="nav__actions">
          {currentUser?.id ? (
            <>
              <Link to="/create" className="btn btn--primary btn--sm">
                <FiPlus /> Write
              </Link>
              <Link to={`/profile/${currentUser.id}`} className="nav__user">
                <span className="avatar avatar--xs">
                  <img
                    src={uploadUrl(currentUser.avatar)}
                    alt=""
                    onError={fallbackTo(FALLBACK_AVATAR)}
                  />
                </span>
                <span>{currentUser.name}</span>
              </Link>
              <Link to="/logout" className="btn btn--ghost btn--sm" aria-label="Log out">
                <FiLogOut />
              </Link>
            </>
          ) : (
            <>
              <Link to="/login" className="btn btn--ghost btn--sm">
                Sign in
              </Link>
              <Link to="/register" className="btn btn--primary btn--sm">
                Get started
              </Link>
            </>
          )}
        </div>

        <button
          className="nav__toggle"
          onClick={() => setOpen((o) => !o)}
          aria-label={open ? "Close menu" : "Open menu"}
          aria-expanded={open}
        >
          {open ? <FiX /> : <FiMenu />}
        </button>
      </div>

      {open && (
        <div className="nav__panel">
          <div className="container">
            {LINKS.map((l) => (
              <NavLink key={l.to} to={l.to} end={l.end}>
                {l.label}
              </NavLink>
            ))}
            {currentUser?.id ? (
              <>
                <NavLink to={`/profile/${currentUser.id}`}>Profile</NavLink>
                <NavLink to={`/myposts/${currentUser.id}`}>My posts</NavLink>
                <NavLink to="/logout">Log out</NavLink>
                <Link to="/create" className="btn btn--primary btn--block">
                  <FiPlus /> Write a post
                </Link>
              </>
            ) : (
              <>
                <NavLink to="/login">Sign in</NavLink>
                <Link to="/register" className="btn btn--primary btn--block">
                  Get started
                </Link>
              </>
            )}
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
